($ => {
  var overlay;
  const $overlay = $('.content-wrapper__overlay');

  overlay = {
    hideOverlay: () => {
      $overlay.removeClass('active');
    },

    showOverlay: () => {
      $overlay.addClass('active');
    }
  };

  window.overlay = overlay;
})(jQuery);
